const mutations = {

}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/team/mutations/index.js